import Vue from 'vue'
import { error500Message } from "@/constants/general";

export function showDefaultErrorMessages(errorRequest){
  if (errorRequest.response && Number(errorRequest.response.status) === 500) {
    Vue.notify({
      type: 'error',
      text: error500Message,
      duration: 10000
    })
  } else if (errorRequest.response && Number(errorRequest.response.status) === 404) {
    Vue.notify({
      type: 'error',
      text: "Recurso não encontrado",
      duration: 10000
    })
  } else if(errorRequest.response && Number(errorRequest.response.status) === 403) {
    Vue.notify({
      type: 'error',
      text: "Erro de autorização",
      duration: 10000
    })
  } else if(errorRequest.response && Number(errorRequest.response.status) === 405) {
    Vue.notify({
      type: 'error',
      text: "Erro de autorização",
      duration: 10000
    })
  } else {
      let message;

      if(errorRequest.response){
          const errors = errorRequest.response.data.errors;
          for (let index in errors) {
            if(!message) {
              message = errors[index][0]
            }
            errors[index] = errors[index][0];
          }
          message = message ? message : "Erro de validação";
      } else {
          message = errorRequest
      }
      Vue.notify({
        type: 'error',
        text: message,
        duration: 10000
      })
  }
}

export default {
  data(){
    return {
      errors: {},
    }
  },
  methods: {
    showDefaultErrorMessages,
  }
};
